// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientSubHeader_container__3GhZm","select":"ClientSubHeader_select__1eSLd","addBtn":"ClientSubHeader_addBtn__7wSfS"};